import paramsFactory from "../../../utils/paramsFactory";
import api from "../../apiConfig";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  //jobs
  index(params) {
    const p = paramsFactory(params);
    return api.get(`/api/admin/jobs?${p}`);
  },
  show(id) {
    return api.get(`/api/admin/jobs/${id}`);
  },
  create(data) {
    return api.post(`/api/admin/jobs`, data);
  },
  update(id, data) {
    return api.put(`/api/admin/jobs/${id}`, data);
  },
  delete(id) {
    return api.delete(`/api/admin/jobs/${id}`);
  },
  //job-applicant
  indexJobApplicant(params) {
    const p = paramsFactory(params);
    return api.get(`/api/admin/job-applicant?${p}`);
  },
};
